import { useState } from "react";
import { Modal, Typography, Button, Space } from "antd";
import { UserInfo } from "../../interface";
import { resetUser } from "../../apiBridge";

interface Props {
  isOpen: boolean;
  user?: UserInfo;
  controller: React.Dispatch<React.SetStateAction<boolean>>;
}

const { Title, Text } = Typography;

const ResetUserModal: React.FC<Props> = ({ isOpen, user, controller }) => {
  const [loadingState, setLoadingState] = useState(false);
  const [OTP, setOTP] = useState("");
  const [showPasswordPage, setShowPasswordPage] = useState(false);

  const onResetUser = async () => {
    if (user) {
      setLoadingState(true);
      const res = await resetUser({ id: user.id });
      setLoadingState(false);
      if (res.status === 200) {
        setShowPasswordPage(true);
        const data = await res.json();
        setOTP(data.temporary_password);
      }
    }
  };

  return (
    <Modal
      footer={null}
      maskClosable={false}
      closeIcon={false}
      centered
      open={isOpen && user !== undefined}
      // width={380}
    >
      <div style={{ marginBottom: 20 }}>
        <Title level={4}>
          {showPasswordPage ? "Reset Success" : "Reset Password"}
        </Title>
        <Text type="secondary">
          {showPasswordPage
            ? "The account password will not be shown once this is closed. Please note it down."
            : "Are you sure you want to reset password for this user? This will log the user out of their account."}
        </Text>
      </div>
      {!showPasswordPage ? (
        <div style={{ textAlign: "right" }}>
          <Space>
            <Button onClick={() => controller(false)}>Cancel</Button>
            <Button type="primary" loading={loadingState} onClick={onResetUser}>
              Reset Password
            </Button>
          </Space>
        </div>
      ) : (
        <div>
          <div
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              padding: "4px 8px",
              height: 32,
              backgroundColor: "#f5f5f5",
            }}
          >
            <Text className="customCopyInput" type="secondary" copyable>
              {OTP}
            </Text>
          </div>
          <div style={{ textAlign: "right", marginTop: 20 }}>
            <Button onClick={() => controller(false)}>Back to Dashboard</Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ResetUserModal;
